import React from "react";
import Banner from "common/Banner/Banner";
import Text from "common/Typography/Text";
import Button from "common/Buttons/Button";
import Flex from "common/Boxes/Flex";
import useMedia from "utils/hooks/useMedia";
import { VERY_SMALL_MOBILE } from "common/constants";
import styled from "styled-components";
import { useTelegramWebRedirect } from "utils/hooks/misc";
import { isTablet } from "react-device-detect";

const TelegramWebAppBanner = () => {
  const isSmallMobile = useMedia(
    [`(max-width: ${VERY_SMALL_MOBILE})`],
    [true],
    false
  );
  const { redirectToWebsite, isLoading } = useTelegramWebRedirect();

  const onButtonClick = () => {
    redirectToWebsite();
  };

  return (
    <StyledBanner $isSmallMobile={isSmallMobile}>
      <Flex style={{ justifyContent: "center" }}>
        <Text>To enjoy the full web experience</Text>
        <StyledButton
          $isTablet={isTablet}
          size="middle"
          onClick={onButtonClick}
          loading={isLoading}
        >
          Click Here
        </StyledButton>
      </Flex>
    </StyledBanner>
  );
};

export default TelegramWebAppBanner;

const StyledBanner = styled(Banner)<{ $isSmallMobile: boolean }>`
  background: ${(p) => p.theme.colors.layoutBgColor};
  border-bottom: ${(p) => p.theme.borders.hard};
  padding: ${(p) =>
    p.$isSmallMobile ? "12px 32px 12px 12px" : "12px 32px 12px 16px"};
`;
const StyledButton = styled(Button).attrs({ type: "primary" })<{
  $isTablet: boolean;
}>`
  margin-right: ${(p) => (p.$isTablet ? 8 : 0)}px;
  margin-left: 20px;
`;
